import { Link, useLocation } from "react-router-dom";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ProductCategory, Product } from "../../types/Generic";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

interface ProductSidebarProps {
  productCategory: ProductCategory;
  onProductSelect: (product: Product) => void;
}

const ProductSidebar: React.FC<ProductSidebarProps> = ({
  productCategory,
  onProductSelect,
}) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const { t } = useTranslation();
  const scrollSidebar = (direction: "up" | "down") => {
    if (sidebarRef.current) {
      const scrollAmount = 150;
      sidebarRef.current.scrollBy({
        top: direction === "up" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <aside className="py-8 px-4 hidden sm:flex items-center sm:flex-col gap-4 bg-[#F7F8F9] justify-center h-full">
      <div className="flex justify-center">
        <ArrowDropUpIcon
          onClick={() => scrollSidebar("up")}
          sx={{ ":hover": { cursor: "pointer" }, color: "#000" }}
          className="border-2 rounded-full"
        />
      </div>

      <div
        ref={sidebarRef}
        className="flex sm:flex-col gap-4 sm:overflow-y-auto sm:max-h-[599px] min-h-[399px] no-scrollbar"
      >
        {productCategory.products?.map((item, index) => {
          const isActive = currentPath.includes(
            item.title.toLowerCase().replace(/\s+/g, "-")
          );

          return (
            <Link
              key={index}
              to={`${productCategory.path}/p=${item.title.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={(e) => {
                e.preventDefault();
                onProductSelect(item);
              }}
              className={`relative flex flex-col justify-end px-4 py-2 min-w-[120px] sm:w-[150px] min-h-[150px] rounded-lg bg-[#FFF] border overflow-hidden group ${
                isActive ? "border-gray-400" : ""
              }`}
            >
              <div
                className="absolute inset-0 transition-all duration-300 transform bg-center -top-8 group-hover:scale-105"
                style={{
                  backgroundImage: `url(${item.images[0]})`,
                  backgroundSize: "120px",
                  backgroundRepeat: "no-repeat",
                }}
              />
              <div className="absolute inset-0 transition-all duration-700 ease-in-out translate-y-full opacity-0 bg-black/20 group-hover:opacity-30 group-hover:translate-y-0" />
              <div className="relative z-10 flex flex-col items-center text-white">
                <p className="font-medium bg-[#ffffff90]  text-[14px] text-black text-center leading-tight">
                  {t(item.title)}
                </p>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="flex justify-center">
        <ArrowDropDownIcon
          onClick={() => scrollSidebar("down")}
          sx={{ ":hover": { cursor: "pointer" }, color: "#000" }}
          className="border-2 rounded-full"
        />
      </div>
    </aside>
  );
};

export default ProductSidebar;
